import {auth} from "../index";
import axios from "axios";
import {API_BASE_URL, isProd} from "../../../components/_shared/application";
import {randomId} from "@natomas-org/core";
import {store} from "../../../store";

export const executeRequest = async (
  endpoint: string,
  payload?: any,
  defaultHeaders?: any
) => {
  const headers: any = defaultHeaders ?? {};

  let authToken = "";
  
  // Enhanced auth debugging
  if (!auth.currentUser) {
    console.error(`🔴 [${endpoint}] No authenticated user found`);
    
  } else {
    try {
      authToken = await auth.currentUser.getIdToken();
      headers["Authorization"] = "Bearer " + authToken;
      
    } catch (tokenError) {
      console.error(`🔴 [${endpoint}] Failed to get auth token:`, tokenError);
    }
  }
  
  if (store?.getState()?.global?.app_version?.current_version) {
    headers["app_version"] =
      store?.getState()?.global?.app_version?.current_version;
  }

  const uri = API_BASE_URL() + endpoint;
  const uuid = `(${randomId(5)}) ${endpoint}`;

  if (!isProd) {
    console.time(uuid);
  }

  if (payload) {
    const response = await axios
      .post(uri, payload, {
        headers,
      })
      .catch((error) => {
        // Enhanced error logging for auth issues
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          console.error(`🔴 [${endpoint}] Authentication/Authorization error:`, {
            status: error.response.status,
            statusText: error.response.statusText,
            hasAuthHeader: !!headers["Authorization"],
            currentUser: !!auth.currentUser
          });
        }
        return null;
      });
    const responseData = response?.data;
    if (responseData?.httpCode === 400) {
      // Enhanced 400 error logging
      console.error(`🔴 [${endpoint}] 400 Error Details:`, {
        error: responseData,
        hasAuthHeader: !!headers["Authorization"],
        currentUser: !!auth.currentUser,
        userId: auth.currentUser?.uid,
        payload: payload
      });
      throw responseData;
    }
    return responseData;
  }

  return axios
    .get(uri, {
      headers,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // Enhanced error logging for GET requests too
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        console.error(`🔴 [${endpoint}] GET Authentication error:`, {
          status: error.response.status,
          hasAuthHeader: !!headers["Authorization"],
          currentUser: !!auth.currentUser
        });
      }
      return null;
    });
};
